import { useEffect, useState } from 'react';
import { ClientApp, ClientAppProps, initPerformanceAnalytics } from '@stitch-fix/sf-next';
import { GraphQLApiProvider } from '../components/GraphQLApiProvider';
import { initializeDatadogLogs } from '../utils/initializeDatadogLogs';

// Initialize performance analytics for your project.
// For configuration options, including how to debug locally or increase
// the sample rate, view guide at:
// https://github.com/stitchfix/sf-next/blob/beta/docs/analytics.md
initPerformanceAnalytics({
  sampleRate: 60
});
initializeDatadogLogs();
const isMocking = process.env.NEXT_PUBLIC_API_MOCKING === 'enabled';
let mocksReady: Promise<void> = Promise.resolve();
if (isMocking) {
  // require is synchronous, which allows MSW to be initialized before the app renders,
  // see: https://github.com/mswjs/msw/discussions/1236
  // eslint-disable-next-line global-require
  ({
    mocksReady
  } = require('../mocks/msw'));
}
const App = (props: ClientAppProps) => {
  // In mock mode, hold the first render until the Mock Service Worker has
  // activated for this document. Otherwise the initial GraphQL requests race
  // the worker and escape to the network, which shows up as flaky browser
  // tests on slower browsers.
  const [ready, setReady] = useState(!isMocking);
  useEffect(() => {
    if (ready) return;
    mocksReady.then(() => setReady(true));
  }, [ready]);
  if (!ready) return null;
  return <ClientApp {...props} GraphQLApiProvider={GraphQLApiProvider} />;
};

// Report on next.js metrics and mark `app_rendered`.
// AUTOGENERATED BY SF-NEXT TO SUPPORT TRACKING PERFORMANCE ANALYTICS.
// DO NOT REMOVE.
export { reportWebVitals } from '@stitch-fix/sf-next';
export default App;